<div class="c-container">
  <div class="c-container__header">
    <h1>404</h1>
    <h2>Opsss!..</h2>
    <p>Você tentou acessar uma página que não existe!</p>
    <span>Estamos redirecionando para a página de login...</span>
  </div>
</div>
